<template>
    <div class="auth_in">
        <template v-if="envName === 'stater'">
          <div class="logo-wrapper">
            <img class="logo stater" src="@/assets/stater/images/logo.svg" alt="" />
          </div>
        </template>
        <template v-else-if="envName === 'grok'">
          <div class="logo-wrapper">
            <img class="logo grok" src="@/assets/images/auth_card.png" alt="" />
          </div>
        </template>
        <template v-else-if="envName === 'arvand'">
          <div class="logo-wrapper">
            <img class="logo arvand" src="@/assets/arvand/images/logo-rus.svg" alt="">
          </div>
        </template>
        <template v-else-if="envName === 'prima'">
          <div class="logo-wrapper">
            <img class="logo prima" src="@/assets/prima/images/prima-sign.png" alt="">
          </div>
        </template>

        <div class="title">{{text('wallet.auth.title')}}</div>
        <BaseButton @click="$router.push({ name: 'Register' })" class="register-btn">
          <template #label>
            {{ text('wallet.auth.register') }}
          </template>
        </BaseButton>
        <div class="text">
            <span>{{text('wallet.auth.already_have')}}</span>
            <router-link :to="{name: 'LogIn'}" class="link_text">{{text('wallet.auth.login')}}</router-link>
        </div>

        <StaterFooter v-if="envName === 'stater'" />
        <GrokPolicy v-if="envName === 'grok'" />
    </div>
</template>

<script>
import StaterFooter from '@/components/StaterFooter.vue'
import GrokPolicy from '@/components/GrokPolicy.vue'
import BaseButton from '@/components/base/buttons/BaseButton.vue'

export default {
    name: "Auth",
    components: {
        StaterFooter,
        GrokPolicy,
        BaseButton
    }
}
</script>

<style lang="scss" scoped>
  .auth_in {
    text-align: center;

    .logo-wrapper {
      width: 328px;
      height: 328px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 32px auto;
    }

    .logo {
      width: 100%;
      &.stater {
        max-width: 182px;
      }
      &.grok {
        max-width: 252px;
      }
      &.arvand {
        max-width: 328px;
      }
      &.prima {
        max-width: 328px;
      }
    }

    .title {
      color: #FFF;
      text-align: center;
      font-family: "Rubik", sans-serif;
      font-size: 30px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      max-width: 335px;
      margin: 0 auto 32px;
    }

    .register-btn {
      margin-bottom: 32px;
    }

    .text {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      span {
        color: #FFF;
        font-family: "Rubik", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 135%;
      }

      .link_text {
        color: var(--text-color-accent);
      }
    }
  }

</style>